module.exports = __webpack_public_path__ + "first-5_watermark.jpg?0b2425c7129dbac373f3e2cff14bd8e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_watermark.jpg
// module id = 593
// module chunks = 0